import React, { useContext } from 'react';
import { Box, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import SideArrow from '../../../../assets/SVGs/SideArrow.svg';
import exclamationGreyCircle from '../../../../assets/SVGs/exclamationGreyCircle.svg';
import styles from './RootCausePanel.module.css';
import {
	POTENIAL_SALES_IMPACT,
	ROOT_CAUSE_WARNING_TEXT,
	GUIDED_INSIGHTS_RCA,
} from '../../../../constants/constant';
import { useDispatch } from 'react-redux';
import { saveEventTrack } from '../../../../redux/actions/eventTrackAction';
import { UserPortalContext } from '../../../../context/appcontext';
import { theme } from '../../../../theme/theme';
import { rootCauseNames } from '../constants';

const removeSign = (value) => {
	const sign = value < 0 ? '-' : '';
	const potential_sales_impact =
		value == '--'
			? value
			: Math.abs(value)?.toLocaleString('en-US', { maximumFractionDigits: 0 });
	return sign + '$' + potential_sales_impact;
};

const RootCauseCard = (props) => {
	const portalUserContext = useContext(UserPortalContext);
	const dispatch = useDispatch();

	const rootCauses = props?.rootCauses;
	const setTab = props?.setTab;

	const updateTab = (id) => {
		const request = {
			event: 'Root Cause Selection',
			event_description: `Root Cause Selection - ${
				rootCauseNames[rootCauses?.domain]
			}`,
			attributes: GUIDED_INSIGHTS_RCA,
		};
		dispatch(saveEventTrack({ request, portalUserContext }));
		setTab(id);
	};

	const isActiveTab = props.tab === props.id ? styles.isActive : styles.onHover;

	const classes = `${isActiveTab} ${styles.rootCauseCard}`;

	const potentialSalesImpact =
		rootCauses?.totalSalesImpact > 0
			? styles.positiveImpact
			: rootCauses?.totalSalesImpact == '' ||
			  rootCauses?.totalSalesImpact == '--'
			? styles.noImpact
			: styles.negativeImpact;

	return (
		<ThemeProvider theme={theme}>
			<Box
				className={classes}
				data-testId={'rootCause' + props.id}
				id={'rootCause' + props.id}
				onClick={() => updateTab(props.id)}>
				<Box className={styles.rootCauseNameContainer}>
					<Box className={styles.rootCauseName}>
						{rootCauseNames[rootCauses?.domain]}
					</Box>
					<Box className={styles.sideArrow}>
						{' '}
						<img alt="arrow" src={SideArrow} />
					</Box>
				</Box>
				<Box className={styles.rootCauseImpactContainer}>
					<Box className={styles.potentialSalesImpactText}>
						{POTENIAL_SALES_IMPACT}
					</Box>
					<Box className={potentialSalesImpact}>
						{removeSign(rootCauses?.totalSalesImpact)}
					</Box>
				</Box>
			</Box>
		</ThemeProvider>
	);
};

RootCauseCard.propTypes = {
	rootCauses: PropTypes.object,
	id: PropTypes.number,
	tab: PropTypes.number,
	setTab: PropTypes.func,
	metrices: PropTypes.string,
};

const RootCausePanel = (props) => {
	const { rootCausesArr, tab, setTab, metrices } = props;

	return (
		<>
			{rootCausesArr?.map((rootCauses, index) => {
				return (
					<RootCauseCard
						key={index}
						id={index}
						tab={tab}
						setTab={setTab}
						metrices={metrices}
						rootCauses={rootCauses}></RootCauseCard>
				);
			})}
			<Box className={styles.warning}>
				<Box className={styles.exclamationCicle}>
					<img src={exclamationGreyCircle} alt="warning"></img>
				</Box>
				<Box className={styles.warningText}>{ROOT_CAUSE_WARNING_TEXT}</Box>
			</Box>
		</>
	);
};

RootCausePanel.propTypes = {
	rootCausesArr: PropTypes.array,
	tab: PropTypes.number,
	setTab: PropTypes.func,
	metrices: PropTypes.string,
};

export default RootCausePanel;
